import { territoriesSlice } from "./territoriesSlice";
import * as actions from "./territoriesActions";
import * as selectors from "./territoriesSelectors";

export { actions };
export { selectors };
export default territoriesSlice.reducer;
